import { Inject, Injectable, InjectionToken } from '@angular/core';



export const HTTP_CONFIG_OPTIONS = new InjectionToken<HttpConfigOptions>('HttpConfigOptionsToken');


export interface HttpConfigOptions {
  baseUrl: string;
  language: string;
}


@Injectable({providedIn: 'root'})
export class HttpConfig {
  readonly baseUrl: string;
  readonly language: string;

  constructor(@Inject(HTTP_CONFIG_OPTIONS) options: Partial<HttpConfigOptions>) {
    this.baseUrl = options.baseUrl || '';
    this.language = options.language;
  }
}
